import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../../core/services';
import { PartnerPlan } from '../../../core/enum';

export const IsPmpDealsEnabledGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.partner.partner_plan !== PartnerPlan.Enterprise || !auth.partner.pmp_deals) {
    router.navigate(['ssp-dsp-dashboard']);

    return false;
  }

  return true;
};
